<template>
  <div>
    <h3 class="text-black mb-4">Vehicle Search</h3>
    <special-filter :fetch_filter="fetchFilterMain" filterType="main" :item_filter="false" @onFilter="updateTable"></special-filter>

    <template v-if="!filter">
      <div class="bg-white py-4 radius-sm">
        <div class="vue_universal_table_table">
          <table class="table table-striped">
            <thead style="background-color: rgb(255, 255, 255)">
              <tr>
                <th class="tableTitle sortable text-center">QR Code</th>
                <th class="tableTitle sortable">Engine Number</th>
                <th class="tableTitle sortable">Frame Number</th>
                <th class="tableTitle sortable">Commercial Name</th>
                <th class="tableTitle sortable">Current Location</th>
                <th class="tableTitle sortable">Current Activity</th>
                <th class="tableTitle sortable">Status</th>
                <th colspan="1" style="text-align: center"><i class="fas fa-cog"></i></th>
              </tr>
            </thead>
          </table>
        </div>
        <div class="d-flex flex-column justify-content-center align-items-center">
          <img class="my-4" :src="require('@/assets/img/icon/no-filter.jpg')" alt="no-filter" />
          <p>Select and search filter to display data</p>
        </div>
      </div>
    </template>
    <template v-else>
      <div class="bg-white py-4 radius-sm">
        <vue-universal-table :api_url="'/api/reports/vehicle-search'" @dataLoaded="handleDataLoaded" :filter="filter" :fields="vue_universal_table.fields" :buttons="vue_universal_table.buttons" :update="vue_universal_table.update" :infinite_scroll="true" @onDetails="loadDetailVehicle"></vue-universal-table>
      </div>

      <template v-if="!isDataAvailable">
        <div class="bg-white py-4 radius-sm text-center">
          <p>Data is not available</p>
        </div>
      </template>
    </template>

    <vehicleDetailModal v-if="showModal" :data="vehicleData" :info="vehicleInfo" @closeModal="showModal = false"></vehicleDetailModal>
  </div>
</template>

<script>
import qs from "qs";
import flatPickr from "vue-flatpickr-component";

import specialFilter from "./children/special_filter";
import vehicleDetailModal from "./children/vehicleDetailModal";

export default {
  data() {
    return {
      showModal: false,
      vehicleData: null,
      vehicleInfo: null,

      filter: null,
      // fetchFilter: 0,
      fetchFilterMain: 0,
      fetchFilterModal: 0,
      loading: false,
      vue_universal_table: {
        fields: [
          {
            title: "QR Code",
            variable: "qrcode",
          },
          {
            title: "Engine Number",
            variable: "engine_no",
          },
          {
            title: "Frame Number",
            variable: "frame_no",
          },
          {
            title: "Commercial Name",
            variable: "commercial_name",
          },
          {
            title: "Current Location",
            variable: "current_loc_code",
          },
          {
            title: "Current Activity",
            variable: "current_activity",
          },
          {
            title: "Status",
            variable: "status",
          },
        ],
        buttons: [
          {
            title: "Details",
            class: "btn-outline-primary fa fa-motorcycle",
          },
        ],
        update: 0,
        dataTable: [],
      },
      showExcelModal: false,
      showModalFilter: false,
      filterModal: {
        dateRange: [],
      },
      rangeConfig: {
        mode: "single",
        altInput: true,
        animate: !this.isRTL(),
      },
    };
  },
  components: {
    specialFilter,
    vehicleDetailModal,

    flatPickr,
  },
  // mounted () {
  //   this.fetchFilter++;
  // },
  computed: {
    isDataAvailable() {
      return this.vue_universal_table.dataTable && this.vue_universal_table.dataTable.length > 0;
    },
  },
  watch: {
    fetchFilterModal(newVal) {
      this.fetchFilterMain = newVal;
    },
  },
  methods: {
    parseFilter(a) {
      this.filter = qs.parse(a);
    },
    updateTable(a) {
      this.parseFilter(a);
      this.vue_universal_table.update++;
      console.log(a);
    },
    initialiseFilter() {
      let queryArray = [];

      // Ensure `this.filter` is a valid object
      if (this.filter && typeof this.filter === "object") {
        Object.keys(this.filter).forEach((key) => {
          let value = this.filter[key];

          // If the value is empty/null, just append the key without `=`
          if (!value || value.length === 0 || value === "All") {
            queryArray.push(key);
          } else {
            queryArray.push(`${key}=${encodeURIComponent(value)}`);
          }
        });
      } else {
        console.warn("Filter is invalid or null, skipping filters.");
      }

      // Ensure `this.range` is valid
      if (this.range) {
        let splitDateRange = this.range.split(" to ");
        if (splitDateRange.length === 2) {
          queryArray.push(`start=${splitDateRange[0]}`);
          queryArray.push(`end=${splitDateRange[1]}`);
        } else {
          console.warn("Invalid date range format:", this.range);
        }
      }

      let finalQuery = queryArray.length ? "?" + queryArray.join("&") : "";
      console.log("Final URL query:", finalQuery);
      return finalQuery;
    },
    handleDataLoaded(data) {
      this.loading = false;
      if (Array.isArray(data)) {
        this.$set(this.vue_universal_table, "dataTable", data);
      } else {
        this.$set(this.vue_universal_table, "dataTable", []);
      }
    },
    loadDetailVehicle(vehicleInfo) {
      this.vehicleData = null;
      this.showModal = false;
      this.vehicleInfo = JSON.parse(vehicleInfo);
      let url = `/api/reports/vehicle-search/tracking/${this.vehicleInfo.engine_no}`;

      this.$http
        .get(url)
        .then((resp) => {
          this.vehicleData = resp.data.data;
          this.showModal = true;
        })
        .catch((err) => {
          console.log(err);
        });
    },
  },
};
</script>
